import { createRouter, createWebHistory } from 'vue-router';
import { translateLang } from '@/utils/lang';
import HomeView from '../views/home/index.vue';

const routes = [
  {
    path: '/',
    name: '首页',
    component: HomeView,
    meta: {
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      pageid: 'page_home',
      fixedNav: true,
    },
  },
  {
    path: '/newcornerstone',
    name: '新基石研究员',
    meta: {
      pageid: 'page_invstgtr_land',
      fixedNav: true,
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      simpleEffects: true,
      // 是否隐藏语言按钮
      // hideLangAction: true,
    },
    component: () => import(/* webpackChunkName: "newcornerstone" */ '../views/newcornerstone/Index.vue'),
  },
  {
    path: '/newcornerstone/dynamic-list',
    name: '新基石研究员-研究进展',
    meta: {
      pageid: 'page_invstgtr_dynmc',
      hideLangAction: true,
    },
    component: () => import('../views/newcornerstone/dynamicsList.vue'),
  },
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "about" */ '../views/about/About.vue'),
    children: [
      {
        path: '',
        meta: {
          pageid: 'page_about_foundation',
        },
        name: '关于基金会',
        component: () => import(/* webpackChunkName: "aboutFoundation" */ '../views/about/AboutFoundation.vue'),
      },
      {
        path: 'foundation',
        meta: {
          pageid: 'page_about_foundation',
        },
        name: '关于基金会',
        component: () => import(/* webpackChunkName: "aboutFoundation" */ '../views/about/AboutFoundation.vue'),
      },
      {
        path: 'organization',
        meta: {
          pageid: 'page_organizational_structure',
        },
        name: '组织架构',
        component: () => import(/* webpackChunkName: "aboutMember" */ '../views/about/AboutMember.vue'),
      },
      {
        path: 'contact-us',
        meta: {
          pageid: 'page_contact_us',
        },
        name: '联系我们',
        component: () => import(/* webpackChunkName: "aboutConcatUs" */ '../views/about/AboutConcatUs.vue'),
      },
      {
        path: 'dangjian/:type?',
        name: '党建工作',
        component: () => import(/* webpackChunkName: "aboutGCD" */ '../views/about/AboutGCD.vue'),
        meta: {
          keepAlive: true,
          pageid: 'page_party_work',
          hideLangAction: true,
        },
      },
      {
        path: 'registration-certificate',
        name: '资质文件',
        meta: {
          pageid: 'page_qualification_documents',
          hideLangAction: true,
        },
        component: () => import(/* webpackChunkName: "aboutFile" */ '../views/about/AboutFile.vue'),
      },
      {
        path: 'dangjian/detail/:id/:type',
        name: '党建工作详情',
        component: () => import(/* webpackChunkName: "AboutGCDDetail" */ '../views/about/AboutGCDDetail.vue'),
        meta: {
          keepAlive: true,
          pageid: 'page_party_work_detail',
          hideLangAction: true,
        },
      },
    ],
  },
  {
    path: '/infomation',
    component: () => import(/* webpackChunkName: "infomation" */ '../views/infomation/Infomation.vue'),
    children: [
      {
        path: '',
        name: '基金会章程',
        meta: {
          pageid: 'page_foundation_rules',
          hideLangAction: true,
        },
        component: () => import(/* webpackChunkName: "infomationRule" */ '../views/infomation/InfomationRule.vue'),
      },
      {
        path: 'charter',
        name: '基金会章程',
        meta: {
          pageid: 'page_foundation_rules',
          hideLangAction: true,
        },
        component: () => import(/* webpackChunkName: "infomationRule" */ '../views/infomation/InfomationRule.vue'),
      },
      {
        path: 'work-report',
        meta: {
          pageid: 'page_work_report',
          hideLangAction: true,
        },
        name: '工作报告',
        // eslint-disable-next-line prettier/prettier
        component: () => import(/* webpackChunkName: "infomationRule" */ '../views/infomation/InfomationWorkReport.vue'),
      },
      {
        path: 'audit-report',
        name: '审计报告',
        meta: {
          pageid: 'page_audit_report',
          hideLangAction: true,
        },
        // eslint-disable-next-line prettier/prettier
        component: () => import(/* webpackChunkName: "infomationRule" */ '../views/infomation/InfomationAuditReport.vue'),
      },
      {
        path: 'manage-policies',
        name: '管理制度',
        meta: {
          pageid: 'page_management_system',
          hideLangAction: true,
        },
        component: () => import(/* webpackChunkName: "infomationRule" */ '../views/infomation/InfomationManageSys.vue'),
      },
    ],
  },
  {
    path: '/news',
    meta: {
      pageid: 'page_news_list',
      hideLangAction: true,
    },
    name: '资讯',
    component: () => import(/* webpackChunkName: "news" */ '../views/news/index.vue'),
  },
  {
    path: '/news-list',
    meta: {
      pageid: 'page_dynmcs_list',
      hideLangAction: true,
    },
    name: '资讯列表',
    component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsList.vue'),
  },
  {
    path: '/terms-of-use',
    meta: {
      pageid: 'page_user_agreement',
      hideLangAction: true,
    },
    name: '用户协议',
    component: () => import(/* webpackChunkName: "userAgreement" */ '../views/UserAgreement.vue'),
  },
  // 科探落地页
  {
    path: '/scientific-explorer',
    name: '科学探索奖',
    component: () => import('../views/scientificExplorer/index.vue'),
    meta: {
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      fixedNav: true,
      // 使用nav简短动画
      simpleEffects: true,
      pageid: 'page_awrdes_land',
    },
  },
  {
    path: '/scientific-explorer/dynamic-list',
    name: '科学探索奖-获奖人动态',
    meta: {
      pageid: 'page_awrdes_dynmc',
      hideLangAction: true,
    },
    component: () => import('../views/scientificExplorer/dynamicsList.vue'),
  },
  {
    path: '/personalityInterview',
    meta: {
      pageid: 'page_prfle_list',
      hideLangAction: true,
    },
    name: '人物专访页',
    component: () => import(/* webpackChunkName: "news" */ '../views/personalityInterview/index.vue'),
  },
  // 学术交流
  {
    path: '/scientific-conference',
    name: '新基石科学会议',
    component: () => import('../views/scientificConference/index.vue'),
    meta: {
      pageid: 'page_scnc_mting',
      fixedNav: true,
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      simpleEffects: true,
      // 是否隐藏语言按钮
      // hideLangAction: true,
    },
  },
  {
    path: '/scientific-conference/dynamic-list',
    name: '新基石科学会议-新闻列表',
    meta: {
      pageid: 'page_scnc_mting_news',
      hideLangAction: true,
    },
    component: () => import('../views/scientificConference/dynamicsList.vue'),
  },
  {
    path: '/webinar',
    name: 'webinar',
    component: () => import('../views/webinar/index.vue'),
    meta: {
      pageid: 'page_webr',
      fixedNav: true,
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      simpleEffects: true,
      // 是否隐藏语言按钮
      hideLangAction: true,
    },
  },
  {
    path: '/webinar/dynamic-list',
    name: 'webinar-新闻列表',
    meta: {
      pageid: 'page_webr_news',
      hideLangAction: true,
    },
    component: () => import('../views/webinar/dynamicsList.vue'),
  },
  {
    path: '/video-list',
    name: 'videoList',
    component: () => import('../views/videoList/list.vue'),
    meta: {
      pageid: 'page_video_list',
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      // 是否隐藏语言按钮
      hideLangAction: true,
    },
  },
  {
    path: '/video/detail/:id',
    name: '视频详情',
    component: () => import(/* webpackChunkName: "VideoDetail" */ '../views/videoList/detail.vue'),
    meta: {
      pageid: 'page_video_detail',
      mobile: true,
      needNav: true,
      lang: 'zh-CN',
      // 是否隐藏语言按钮
      hideLangAction: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, saveTop) {
    let save = {};
    if (saveTop) {
      save = saveTop;
    } else {
      save = { left: 0, top: 0 };
    }
    return save;
  },
});

router.beforeEach((to, from, next) => {
  console.log(from, '===');
  // 结束上页曝光
  window.$_report.Send('pageOut', from.meta.pageid);
  window.$_report.Send('pageIn', to.meta.pageid);
  if (to.meta.hideLangAction) {
    translateLang('zh-CN');
  }
  next();
});

export default router;
